import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.nav.sidebar');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { accountInitial, getDemoAccount } from '../admin-prototype/account';

@Component({
    selector: 'wiz-component-nav-sidebar',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/component.nav.sidebar/view.scss */
/* src/app/component.nav.sidebar/view.scss: no such file or directory */`],
})
export class ComponentNavSidebarComponent implements OnInit {
    public account = getDemoAccount();

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        this.account = getDemoAccount(this.service.auth.context);
        await this.service.render();
    }

    public isActive(link: string, tab: string = '') {
        if (link === '/management') {
            const section = new URLSearchParams(location.search).get('section');
            return location.pathname === '/management' && (!section || section === 'offices');
        }
        if (link === '/transaction') {
            const section = new URLSearchParams(location.search).get('section') || 'dashboard';
            return location.pathname === '/transaction' && section === (tab || 'dashboard');
        }
        if (link === '/ip-management/sends' && tab) {
            const currentTab = new URLSearchParams(location.search).get('tab') || 'quotes';
            return this.matchesPath(link) && currentTab === tab;
        }
        if (link === '/ip-management/import') {
            return this.matchesPath('/ip-management/import') || this.matchesPath('/ip-management/offices');
        }
        return this.matchesPath(link);
    }

    private matchesPath(link: string) {
        return location.pathname === link || location.pathname.indexOf(link + '/') === 0;
    }

    public activeClass(link: string, tab: string = '') {
        const tone = this.linkTone(link);
        const base = 'wb-sidebar-link group flex items-center gap-x-2 rounded-md px-2 py-2 text-[13px] transition-all duration-300';
        if (this.isActive(link, tab)) {
            if (tone === 'management') return base + ' bg-emerald-700 font-semibold text-white';
            if (tone === 'market') return base + ' bg-cyan-700 font-semibold text-white';
            return base + ' bg-slate-900 font-semibold text-white';
        }
        if (tone === 'management') return base + ' font-medium text-gray-600 hover:bg-emerald-50 hover:text-emerald-800';
        if (tone === 'market') return base + ' font-medium text-gray-600 hover:bg-cyan-50 hover:text-cyan-800';
        return base + ' font-medium text-gray-600 hover:bg-gray-100 hover:text-gray-950';
    }

    private linkTone(link: string) {
        if (link.indexOf('/management') === 0 || link.indexOf('/ip-management') === 0) return 'management';
        if (link.indexOf('/transaction') === 0 || link.indexOf('/ip-market') === 0) return 'market';
        return 'default';
    }

    public isManagementConsole() {
        const path = location.pathname;
        return path.indexOf('/transaction') !== 0 && path.indexOf('/ip-market') !== 0;
    }

    public isTransactionConsole() {
        const path = location.pathname;
        return path.indexOf('/transaction') === 0 || path.indexOf('/ip-market') === 0;
    }

    public logoRoute() {
        const path = location.pathname;
        if (path.indexOf('/transaction') === 0 || path.indexOf('/ip-market') === 0) return '/transaction';
        if (path.indexOf('/management') === 0 || path.indexOf('/ip-management') === 0) return '/management';
        return '/dashboard';
    }

    public initial() {
        return accountInitial(this.account);
    }
}

export default ComponentNavSidebarComponent;